<template>
  <div class="recovery_wrapper">
    <van-nav-bar
      title="补缴清单"
      @click-left="$utils.goBack()"
      @click-right="showCondition = !showCondition"
    >
      <template #left>
        <span class="icon-left"></span>
      </template>
      <template #right>
        <div class="nav_right_icon">
          <span class="icon-search1">
            <span class="path1"></span>
            <span class="path2"></span>
            <span class="path3"></span>
          </span>
        </div>
      </template>
    </van-nav-bar>

    <div class="recovery_list">
      <list-view
        :list="notesList"
        :isRefresh="isRefresh"
        :isLoadMore="isLoadMore"
        :isNoMore="isNoMore"
        :isErr="isErr"
        :isAutoLoadMore="isAutoLoadMore"
        @onLoadMore="onListLoadMore"
        @onRefresh="onListRefresh"
      >
        <!-- 订单列表 -->
        <template slot="item">
          <div class="notes_list">
            <li
              @click="onClickItem(item.plateNumber, item.id)"
              class="notes_item"
              v-for="(item, index) in notesList"
              :key="index"
            >
              <div class="item_top">
                <div class="car_license">
                  {{ item.plateNumber }}
                  <span
                    class="item_orderStatus"
                    :class="{
                      fail: $condition.isOrderStatus_fail(item.orderStatus),
                    }"
                    >{{ item.orderStatus | orderStatusFilter }}</span
                  >
                </div>
                <div class="item_cost">{{ item.payableAmount }}元</div>
              </div>

              <div class="item_middle">
                <div class="car_pid">{{ item.parkingNumber }}</div>
              </div>
              <div class="item_bottom">
                <div class="item_time">{{ item.leaveTime }}</div>
                <div class="item_duration">
                  {{ item.stayTime | timeTransformation }}
                </div>
              </div>
            </li>
          </div>
        </template>
      </list-view>
    </div>

    <div class="recovery_bar">
        <div class="recovery_total">共 <span>{{totalCount}}</span> 张订单</div>
        <div class="recovery_total">合计：<span>1000</span> 元</div>
        <div class="recovery_btn">
            补 缴
        </div>
    </div>
  </div>
</template>

<script>
import listView from "../../components/ListView";
import { ORDER_PARKING_EXCEPTION_ORDER_PARKING_LIST } from "../../config/config";
import { Toast } from "vant";
export default {
  components: {
    listView,
  },
  data: () => ({
    isRefresh: false, //刷新
    isLoadMore: false, //加载
    isNoMore: false, //加载完毕
    isErr: false, //报错
    notesList: [], //订单列表
    isAutoLoadMore: true, //自动加载
  }),
  methods: {
    //列表加载
    onListLoadMore() {
      this.isLoadMore = true;

      //防抖
      clearTimeout(this.loadTimer);
      this.loadTimer = setTimeout(() => {
        this.loadTimer = null;
        //请求数据
        this.$request(
          ORDER_PARKING_EXCEPTION_ORDER_PARKING_LIST,
          {
            lastId: this.lastId,
            orderStatus: this.conditionRadio,
          },
          (res) => {
            if (res["data"]["orderParkingList"]) {
              let data = res["data"]["orderParkingList"];
              if (data.length > 0) {
                //记录数据，赋值
                this.isLoadMore = false;
                this.lastId = data[data.length - 1]["id"];

                data.forEach((item) => {
                  this.notesList.push(item);
                });
              } else {
                this.isNoMore = true;
              }
            } else {
              Toast("数据请求失败，请重试");
            }
          }
        );
      }, 500);
    },

    //列表刷新
    onListRefresh() {
      this.isRefresh = true;

      //防抖
      clearTimeout(this.refreshTimer);
      this.refreshTimer = setTimeout(() => {
        this.refreshTimer = null;
        this.requestRefreash();
      }, 500);
    },
  },
  computed : {
    totalCount(){
      return this.notesList.filter(item => item.checked).length ;
    }
  },
};
</script>

<style lang="less">
.recovery_wrapper {
  width: 100vw;
  height: 100vh;
  background-color: #fff;
  position: absolute;
  top: 0;
  left: 0;
  overflow: hidden;
  padding-top: 26px;

  .icon-left {
    font-size: 24px;
    margin-right: 6px;
    color: #333;
  }

  .nav_right_icon {
    font-size: 24px;
    color: #666;
  }

  /deep/ .van-nav-bar__title {
    font-size: 20px;
  }
}

.recovery_test {
  width: 100%;
  height: 1000px;
  background-color: red;
}

.recovery_list {
  position: absolute;
  top: 66px;
  bottom: 60px ;
  width: 100%;
  overflow: hidden;
  // transition: top 0.5s;

  // &.active {
  //   top: 152px;
  // }

  .notes_list {
    width: 100%;
    padding: 0 20px;
  }

  .notes_item {
    width: 100%;
    min-height: 88px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    font-size: 20px;
    padding: 10px 0;
    border-bottom: 1px solid rgba(7, 17, 27, 0.1);

    .item_top {
      display: flex;
      justify-content: space-between;
      margin-bottom: 8px;

      .car_license {
        color: #000;
        font-weight: 700;
        font-size: 20px;

        .item_orderStatus {
          margin-left: 20px;
          color: skyblue;

          &.fail {
            color: red;
          }
        }
      }
      .item_cost {
        color: red;
        font-size: 20px;
        font-weight: 600;
      }
    }

    .item_middle {
      margin-bottom: 8px;

      .car_pid {
        color: #333;
        display: inline-block;
        width: 240px;
        vertical-align: baseline;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }

    .item_bottom {
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: rgb(129, 129, 129);
      font-size: 18px;
    }
  }
}

.recovery_bar{
    height : 60px ;
    width : 100%;
    border-top-left-radius: 10px ;
    border-top-right-radius: 10px ;
    background-color :#0b0b0b;
    position : absolute ;
    bottom : 0 ;
    display: flex ;
    justify-content: space-between;
    align-items: center ;
    padding : 12px ;

    .recovery_total {
        color : #8c8c8c ;
        font-size : 16px ;

        span{
            color : #ec132d ;
            font-size : 20px ;
        }
    }

    .recovery_btn{
        width : 80px ;
        height : 36px ;
        background-color :#2b5fe6;
        border-radius: 20px ;
        display: flex ;
        justify-content: center ;
        align-items: center ;
        color : #fff ;
        font-size : 20px ;
    }
}
</style>
